import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import InvoicesService from "../../Services/http/InvoicesService";

export const downloadReimbursementsToCharge = async (dispatch, account_id, invoice_id=null) => {
    dispatch(setIsActiveSpinner(true));
    await InvoicesService.downloadReimbursementsToCharge(account_id, invoice_id);
    dispatch(setIsActiveSpinner(false));
};

export const getBillingsInfo = async (dispatch, account_id) => {
    dispatch(setIsActiveSpinner(true));
    const response = await InvoicesService.getBillingsInfo(account_id);
    dispatch(setIsActiveSpinner(false));
    return response;
};


export const getInvoiceDetailsPage = async (dispatch, account_id, invoice_id) => {
    dispatch(setIsActiveSpinner(true));
    const response = await InvoicesService.getInvoiceDetailsPage(account_id, invoice_id);
    dispatch(setIsActiveSpinner(false));
    return response;
};
